module.exports = __webpack_public_path__ + "static/service3-7e6901d327eb1d97beaa342d35dd0e18.jpg";